<template>
    <!-- STATISTIC-1
    ============================================= -->
    <div id="statistic-1" class="bg-01 pt-70 pb-70 statistic-section division">
        <div class="container white-color">
            <!-- fetch this information form DB -->

            <!-- STATISTIC-1 WRAPPER -->
            <div class="statistic-1-wrapper">
                <div class="row justify-content-md-center row-cols-1 row-cols-md-3">


                    <!-- STATISTIC BLOCK #1 -->
                    <div id="sb-1-1" class="col">
                        <div class="statistic-block wow fadeInUp">

                            <!-- Digit -->
                            <p class="h2-xl statistic-number"><span class="count-element">{{statistics.diy}}</span></p>

                            <!-- Text -->
                            <h5 class="h5-lg">Total DIY Users</h5>

                            <!-- Text -->
                            <p class="p-lg">
                                Total Creditfixrr.com Users In Counting.
                            </p>

                        </div>
                    </div>

                    <div id="sb-1-2" class="col">
                        <div class="statistic-block wow fadeInUp">

                            <!-- Digit -->
                            <p class="h2-xl statistic-number"><span class="count-element">{{statistics.business_users}}</span></p>

                            <!-- Text -->
                            <!--  -->
                            <h5 class="h5-lg">Total Business Users</h5>

                            <!-- Text -->
                            <p class="p-lg">
                                Total Creditfixrr.com Business Users In Counting.
                            </p>

                        </div>
                    </div>

                    <!-- STATISTIC BLOCK #2 -->
                    <div id="sb-1-2" class="col">
                        <div class="statistic-block wow fadeInUp">

                            <!-- Digit -->
                            <p class="h2-xl statistic-number"><span class="count-element">{{statistics.disputeletters}}</span></p>

                            <!-- Text -->
                            <!--  -->
                            <h5 class="h5-lg">Total Disputes</h5>

                            <!-- Text -->
                            <p class="p-lg">
                                Total Dispute Letters In Counting.
                            </p>

                        </div>
                    </div>


                </div>
            </div>	<!-- END STATISTIC-1 WRAPPER -->


        </div>	 <!-- End container -->
    </div>	 <!-- END STATISTIC-1 -->
</template>
<script>
export default{
    props: {
        statistics: {
            type: [Array, Object]
        }
    },
    mounted(){
    },
    methods:{

    }
}

</script>
